import React, { Component } from 'react';
import { Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import config from '../config';
import axios from 'axios';

const BACKEND_URL = config.backend.host;

const styles = theme => ({
  button: {
    margin: theme.spacing()
  },
});

class FileUpload extends Component {
    state = {
        local_file_image: '',
    };

    constructor(props){
      super(props);
      this.fileType = this.props.fileType || '*/*';
    }

    handleChangeLogo(e){
      const fileMaxSizeMb =  this.props.maxFileMb || 2;

      if (e.target.files && e.target.files[0]){
        if (e.target.files[0].size < (fileMaxSizeMb*(1024**2))){
          const file = e.target.files[0];
          const formData = new FormData();
          formData.append('image', file, file.name);
          axios.post(BACKEND_URL + '/upload', formData)
          .then(res => this.props.cbFunction(res.data.fileUrl))
          .catch(e => this.proccessError(e));
        } else {
          alert(`The maximum file size allowed to upload is ${fileMaxSizeMb} MB`);
        }
      }
    }

    proccessError(e){
      if (e.response){
        if (e.response.status === 422){
          alert(`Error uploading file: It looks like your conection is too slow to upload a file of this size.`);
        } else {
          alert(`Error uploading file: ${e} | Response: ${e.response ? e.response.data.message : e.response.message}`);
        }
      } else {
        alert(`Error uploading file: ${e} | Response: No Response`);
      }
    }
    
    render(){
    
    const { classes } = this.props;
    const timestamp = Date.now();

    return(
      <div>
        <input
            accept={this.fileType}
            style={{display:'none'}}
            id={`contained-button-file${timestamp}`}
            type="file"
            onChange={this.handleChangeLogo.bind(this)}
            value={this.state.local_file_image} 
        />
        <label htmlFor={`contained-button-file${timestamp}`}>
        <Button variant="contained" component="span" className={classes.button}>
            {this.props.children}
        </Button>
        </label>  
      </div>
    );
  }
}

export default withStyles(styles)(FileUpload);